<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const baseConfig = parseAndValidateConverterConfig('svg-to-png-converter', 'SVG → PNG');

// Merge base config with SVG→PNG specific labels
const converterConfig = {
  ...baseConfig,
  jobCategory: 'image.svg-to-png',
  labels: {
    dropzoneHeading: 'Drop SVG Files Here',
    emptyQueueMessage: 'Drop SVG files to start your first conversion.',
    statsLabel: 'Median SVG → PNG time (last 10k jobs): {p50TimeMs}',
    batchCompleteTitle: 'All {n} files converted successfully!',
    batchInProgressTitle: 'Converting {n} files...',
  },
  supportUrl: '/contact',
  pricingUrl: '/pricing',
};

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[SVG Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[SVG Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[SVG Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[SVG Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[SVG Converter] Credits updated:', credits);
}
</script>
